import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-o-ring-cord',
    templateUrl: './o-ring-cord.component.html',
    styleUrls: [
        './o-ring-cord.component.scss',
    ],
    standalone: false
})
export class ORingCordComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "O-ring Cord", "data-type": "string"});
    this.title.setTitle(`O-Ring Cord Kits | Marco Sealing Solutions`);
  }

  ngOnInit() {
  }

}
